export default "__VITE_ASSET__CeJCH7l5__"